'use client';

import { useTranslations } from 'next-intl';
import { Icon } from '@/lib/ui-kit/icons';
import { cn } from '@/lib/ui-kit/utils';
import type { SearchCategory } from '../core/types';
import { SECTION_ENTER_CLASS } from './motion';

interface EmptyPreviewProps {
  /** The tab whose picks came back empty; none under All. */
  category?: SearchCategory;
}

/**
 * The search before a query when every section came back empty or failed.
 * It always sits last in the list and shows only as its one child (`only:`),
 * so no section has to report its loading up.
 */
export function EmptyPreview({ category }: EmptyPreviewProps) {
  const t = useTranslations('search');
  const title = category ? t('nothingIn', { category: t(`tabs.${category}`) }) : t('nothingHere');

  return (
    <div
      className={cn(
        'my-auto hidden flex-col items-center gap-1.5 px-4 py-6 text-center only:flex',
        SECTION_ENTER_CLASS,
      )}
    >
      <Icon name="Search" size={24} className="mb-1 text-v2-text-secondary" aria-hidden />
      <p className="text-[13px] font-semibold text-v2-text-primary">{title}</p>
      <p className="text-[12px] leading-[1.4] text-v2-text-secondary">{t('nothingHereHint')}</p>
    </div>
  );
}
